var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showFilter":false,"showSearch":false,"showExportation":false},on:{"addEvent":function($event){return _vm.$router.push({name: 'addDocuments'})}}},[_vm._v("المستندات")]),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":"acceptance-docs","baseURL":_vm.VUE_APP_VETE_LINK}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }